import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { displayFormattedDate, formatCurrency } from '../../../generalFunctions';
import { FIRM_NAME } from '../../../constants';

const styles = StyleSheet.create({
    rowView: {
        flexDirection: 'row', border: '1px solid #000', padding: 10, textAlign: "left", alignSelf: "flex-start", marginRight: 25
    }
});

const PeriodwiseTotalGSTList = (props) => {
    const { startDate, endDate } = props.dates;
    const cgstRate = props.data[0]?.cgstRate;
    const sgstRate = props.data[0]?.sgstRate;
    const igstRate = props.data[0]?.igstRate;
    let totalTaxable = 0; let totalCGST = 0; let totalSGST = 0; let totalIGST = 0;
    props.data?.forEach((element, index) => {
        element.invoiceDate = displayFormattedDate(element.invoiceDate);
        element.amount = Number(element.amount).toFixed(2);
        totalTaxable = totalTaxable + element.taxable;
        totalCGST = totalCGST + element.cgst;
        totalSGST = totalSGST + element.sgst;
        totalIGST = totalIGST + element.igst;
        element.taxable = Number(element.taxable).toFixed(2);
        element.cgst = Number(element.cgst).toFixed(2);
        element.sgst = Number(element.sgst).toFixed(2);
        element.igst = Number(element.igst).toFixed(2);
    });

    props.data.push({
        taxable: totalTaxable.toFixed(2),
        cgst: totalCGST.toFixed(2),
        sgst: totalSGST.toFixed(2),
        igst: totalIGST.toFixed(2)
    });

    const tableData = {
        columnName: ["Inv No", "Inv Dt", "Party Name", "GSTIN", "Taxable", `CGST ${Number(cgstRate).toFixed(2)}`, `SGST ${Number(sgstRate).toFixed(2)}`, `IGST ${Number(igstRate).toFixed(2)}`, "St. Code"],
        column: ["id", "invoiceDate", "accountName", "gstNumber", "taxable", "cgst", "sgst", "igst", "stateCode"],
        width: [7, 7, 35, 13, 10, 7, 7, 7, 7],
        align: ["left", "left", "left", "left", "right", "right", "right", "right", "right"],
        data: props.data
    }

    return (
        <Page style={{ padding: 15 }} id={props.data.id} orientation="landscape">
            <View style={{ flexDirection: "row", paddingBottom: 5, paddingTop: 7, alignSelf: "center" }}>
                <Text style={{
                    fontSize: 16,
                    flexDirection: "column",
                    flexGrow: 1
                }}>{FIRM_NAME}</Text>
            </View>
            <View style={{ flexDirection: 'row', textAlign: "center", marginBottom: 15 }}>
                <Text style={{ fontSize: 9, fontWeight: "bold" }}>{`GST Tax report for the period: ${displayFormattedDate(startDate)} To ${displayFormattedDate(endDate)}`}</Text>
            </View>
            <Fragment>
                <View style={styles.rowView}>
                    {tableData["columnName"].map((c, index) => <Text key={index} style={{
                        width: `${tableData["width"][index]}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9
                    }}>{c.toUpperCase()}</Text>)}
                </View>
                {tableData["data"].map((rowData) => <>
                    <View style={{ flexDirection: 'row', border: '1px solid #000', padding: 10, alignSelf: "flex-start", marginRight: 25 }}>
                        {tableData["column"].map((c, index) =>
                            <Text key={index} style={{ width: `${tableData["width"][index]}%}%`, textAlign: `${tableData["align"][index]}`, fontSize: 9 }}>{rowData[c]}</Text>
                        )}
                    </View>
                </>)}
            </Fragment>
        </Page>
    );
}

export default PeriodwiseTotalGSTList;